module.exports = __webpack_public_path__ + "img/kommune-1441.835705e8.svg";